import gql from "graphql-tag";
import { THIRTY_SECONDS } from "core/constants";
import { usePageVisibilityPolling } from "core/hooks/usePageVisibilityPolling";
import { useRefetchableQuery } from "core/hooks/useRefetchableQuery";
import { GetNotificationsTotal as GetNotificationsTotalGenerated } from "core/queries/__generated__/GetNotificationsTotal";

export interface GetNotificationsTotalResponse
  extends GetNotificationsTotalGenerated {}

export const getNotificationsTotal = gql`
  query GetNotificationsTotal {
    userNotificationTotal {
      total
    }
  }
`;

export interface UseGetNotificationsTotalPollingQueryOptions {
  pollInterval?: number;
  skip?: boolean;
}

export const useGetNotificationsTotalPollingQuery = ({
  pollInterval = THIRTY_SECONDS,
  skip = false,
}: UseGetNotificationsTotalPollingQueryOptions) => {
  const { data, error, loading, refetch, startPolling, stopPolling } =
    useRefetchableQuery(getNotificationsTotal, {
      pollInterval,
      skip,
    });
  usePageVisibilityPolling({
    pollInterval,
    refetch,
    startPolling,
    stopPolling,
  });
  return {
    data,
    error,
    loading,
  };
};
